module.exports = __webpack_public_path__ + "img/hammer-wrench.e593c3ab.svg";